import { useState, useRef, useEffect } from 'react';
// import { MedicineTable } from './medicineTable';
import './addStock.css';
import { toast } from 'react-toastify'
import { AddItemButton } from './buttonComponent';
import BillDetails from './billdetails'
import { CREATE_PURCHASE_ORDER } from '../../GraphQLQueries/mutation';
import useMutationApi from '../../../../../hooks/useMutation';
import { ToastMessageContainer } from '../../../../../_ePulse/layout/components/ToastMessageContainer';
import { success } from '../../../../../data/Status/success';
import { UploadImage } from './utils/uploadImageModal';
import moment from 'moment';
import { LoadingSpinner } from '../../../../../_ePulse/layout/components/LoadingSpinner';
import { NewMedicineTable } from './newMedicineTable';
import { useLocation, useNavigate } from 'react-router-dom';

interface LocationState {
    vendorId?: string;
}

const AddStockPage = (Props: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const vendorId = (location.state as LocationState)?.vendorId || '';


    const { createData, loading, error, data } = useMutationApi(CREATE_PURCHASE_ORDER);
    const [orderDetails, setOrderDetails] = useState([]);
    const [orderInput, setOrderInput] = useState({});

    const [isManualForm, setManualForm] = useState(false);
    const [isOCRFlow, setOCRFlow] = useState(false);
    const [isShowBillDetail, setShowBillDetail] = useState(false);

    const [invoiceNum, setInvoiceNum] = useState('');
    const [invoiceNumError, setInvoiceNumError] = useState('');

    const [invoiceDate, setInvoiceDate] = useState('');
    const [invoiceDateError, setInvoiceDateError] = useState('');
    const [billDetailsfields, setBillDetails] = useState({});

    const [isLoading, setLoading] = useState(false);

    const billDetailsRef = useRef<HTMLDivElement | null>(null);
    const invoiceNumRef = useRef<HTMLInputElement | null>(null);
    const invoiceDateRef = useRef<HTMLInputElement | null>(null);

    const handleInvoiceNumber = (value: any) => {
        setInvoiceNum(value);
        setShowBillDetail(false);
    }
    const handleInvoiceDate = (value: any) => {

        setInvoiceDate(value);
        setShowBillDetail(false);
    }

    useEffect(() => {
        if (billDetailsRef.current && isShowBillDetail) {
            billDetailsRef.current.scrollTop = billDetailsRef.current?.scrollHeight;
        }
    }, [isShowBillDetail])

    const checkInputs = () => {
        if (invoiceNum.trim() === '') {
            invoiceNumRef.current?.focus();
            if (billDetailsRef.current) billDetailsRef.current.scrollTop = -500;
            setInvoiceNumError("Invoice number is required");
            return false;
        }
        if (invoiceDate.trim() === '') {
            setInvoiceNumError('')
            invoiceDateRef.current?.focus();
            setInvoiceDateError("Invoice Date is required");
            return false;
        }
        setInvoiceNumError('')
        setInvoiceDateError('')
        return true;

    }

    const convertExpiryDateIntoISOString = (expiryDate: any) => {

        const date = new Date(expiryDate);


        const isoString = date.toISOString();

        return isoString;
    };

    const convertExpiryDate = (expiryDate: string) => {
        if (typeof expiryDate !== 'string' || expiryDate === '0') {
            return null;
        }

        const isDashFormat = expiryDate.includes('-');
        const isSlashFormat = expiryDate.includes('/');

        let [month, year] = isDashFormat
            ? expiryDate.split('-')
            : isSlashFormat
                ? expiryDate.split('/')
                : [null, null];

        if (!month || !year) {
            return null;
        }

        const formattedDate = `${year}-${month.padStart(2, '0')}-01`;

        const lastDateOfMonth = moment(formattedDate, 'YYYY-MM-DD').endOf('month');
        const formattedString = lastDateOfMonth.format('YYYY-MM-DD');
        return formattedString;
    }

    // const handleOCRMedicineData = (props: any) => {

    //     const orderDetails: [] = props.orderDetail.map((data: any) => {
    //         const rate = parseFloat(data?.RATE);
    //         const qty = parseFloat(data?.QTY);

    //         const value = data?.VALUE
    //             ?? (!isNaN(rate) && !isNaN(qty)
    //                 ? (rate * qty).toFixed(2)
    //                 : null);
    //         return {
    //             PRODUCT_NAME: data?.PRODUCT_NAME,
    //             EXPIRY_DATE: convertExpiryDate(data?.EXPIRY_DATE), // Changed to uppercase
    //             MANUFACTURER: data?.MANUFACTURER,
    //             VALUE: value,
    //             PACK_UNIT: data?.UNIT,
    //             HSNCODE: data?.HSNCODE,
    //             BATCH_NUMBER: data.BATCH,
    //             PACK_SIZE: parseFloat(data?.PACK), // Changed to uppercase
    //             RATE: parseFloat(data?.RATE), // Changed to uppercase
    //             QTY: parseFloat(data?.QTY), // Changed to uppercase
    //             DISCOUNT: data?.DISCOUNT ? parseInt(data?.DISCOUNT) : 0, // Changed to uppercase
    //             CGST: data?.CGST ? parseFloat(data?.CGST) : 0, // Changed to uppercase
    //             SGST: data?.SGST ? parseFloat(data?.SGST) : 0, // Changed to uppercase
    //             MRP: parseFloat(data?.MRP), // Changed to uppercase
    //             GENERIC: data?.GENERIC === "Not Available" || data?.GENERIC === "undefined" || data?.GENERIC === "" ? null : data?.GENERIC, // Changed to uppercase
    //             FREE: parseFloat(data?.FREE) || null

    //         }
    //     })

    //     setOrderDetails(orderDetails);
        
    //     setManualForm(true);
    // }

    const handleOCRMedicineData = (props: any) => {

  const safeNumber = (val: any) => {
    const num = parseFloat(val);
    return isNaN(num) ? null : num;
  };

  const safeString = (val: any) => {

    if (
      val === undefined ||
      val === null ||
      val === "" ||
      val === "undefined" ||
      val === "null" ||
      val === "Not Available"
    ) {
      return null;
    }
    return String(val).trim();
  };

  const orderDetails = (props.orderDetail || []).map((data: any) => {
    const rate = safeNumber(data?.RATE);
    const qty = safeNumber(data?.QTY);

    const value =
      data?.VALUE && !isNaN(parseFloat(data?.VALUE))
        ? parseFloat(data?.VALUE).toFixed(2)
        : rate !== null && qty !== null
        ? (rate * qty).toFixed(2)
        : null;

        console.log("data?.UNIT", data?.UNIT);

    return {
      PRODUCT_NAME: safeString(data?.PRODUCT_NAME),
      EXPIRY_DATE: convertExpiryDate(data?.EXPIRY_DATE),
      MANUFACTURER: safeString(data?.MANUFACTURER),
      VALUE: value,
      PACK_UNIT: safeString(data?.UNIT),
      HSNCODE: safeString(data?.HSNCODE),
      BATCH_NUMBER: safeString(data?.BATCH),
      PACK_SIZE: safeNumber(data?.PACK),
      RATE: rate,
      QTY: qty,
      DISCOUNT: safeNumber(data?.DISCOUNT) || 0,
      CGST: safeNumber(data?.CGST) || 0,
      SGST: safeNumber(data?.SGST) || 0,
      MRP: safeNumber(data?.MRP),
      GENERIC: safeString(data?.GENERIC),
      FREE: safeNumber(data?.FREE),
    };
  });

  console.log("orderDetails from OCR --------", orderDetails);

  setOrderDetails(orderDetails);
  setManualForm(true);
};

    const handleTableData = (props: any) => {
        const orderDetails = props.map((data: any) => ({
            productId: data?.productId || '',
            productName: data?.PRODUCT_NAME,
            expriryDate: convertExpiryDateIntoISOString(data?.EXPIRY_DATE),
            manufacutureDate: invoiceDate,
            manufacturer: data?.MANUFACTURER,
            packUnit: data?.PACK_UNIT,
            hsnCode: data?.HSNCODE,
            batchNumber: data.BATCH_NUMBER,
            pack: parseFloat(data?.PACK_SIZE),
            rate: parseFloat(data?.RATE),
            quantity: parseFloat(data?.QTY),
            discount: data?.discount ? parseInt(data?.DISCOUNT) : 0,
            cgst: data?.cgst ? parseFloat(data?.CGST) : 0,
            sgst: data?.sgst ? parseFloat(data?.SGST) : 0,
            mrp: parseFloat(data?.MRP),
            generic: data?.GENERIC === "Not Available" || data?.GENERIC === "undefined" || data?.GENERIC === "" ? null : data?.GENERIC,
            freeQuantity: parseFloat(data?.FREE) || null,
        }))
        setOrderDetails(orderDetails);
    }

    const handleManuallyDetails = () => {
        setManualForm(!isManualForm);
        //    
    }

    const handleShowOCR = () => {
        setOCRFlow(true);
    }

    const onSubmitDetails = (props: any) => {

        if (checkInputs()) {

            setShowBillDetail(true);

            let initialValues = {
                totalAmount: props.result.totalAmount,
                cashDiscount: props.result.cashDiscount,
                discountAmount: props.result.discountAmount,
                sgstPayable: props.result.sgstPayable,
                cgstPayable: props.result.cgstPayable,
                netAmount: props.result.netAmount,

            }
            setBillDetails(initialValues);

            const orderInput = {
                vendorId: vendorId,
                invoiceNo: invoiceNum,
                totalUnits: props.result.totalUnits,
                invoiceDate: convertExpiryDateIntoISOString(invoiceDate),
                cashIn: 0,
                cashOut: parseFloat('0'),
                outstandingAmount: parseFloat('0') < parseFloat(props.result.netAmount) ? parseFloat(props.result.netAmount) - parseFloat('0') : 0,
                transactionAmount: parseFloat(props.result.netAmount),
                paymentStatus: 'COMPLETED',
                totalAmount: props.result.netAmount,
                netAmount: props.result.netAmount,
                totalSgst: parseFloat(props.result.sgstPayable),
                totalCgst: parseFloat(props.result.cgstPayable),
                totalGstAmount: parseFloat(props.result.sgstPayable + props.result.cgstPayable)
            }

            setOrderInput(orderInput);
        }
    }

    const handleApiCall = async () => {
        setLoading(true);
        try {
            const result = await createData({
                orderInput: orderInput, orderDetails: orderDetails
            });
            setLoading(false);
            toast.success(success.CREATE_PURCHASE_ORDER);
            setTimeout(() => {
                navigate("/pharmacy/dashboard");
            }, 1500)

        }
        catch (error: any) {
            setLoading(false);
        }
    }


    return <div ref={billDetailsRef} >
        {/* {isManualForm && <AddMedicneManually/>} */}
        <LoadingSpinner isLoading={isLoading} />
        <div>
            <ToastMessageContainer />
        </div>
        {isOCRFlow && <UploadImage modalState={isOCRFlow} closeModal={() => { setOCRFlow(false) }} handleOCRMedicineData={handleOCRMedicineData} />}
        {/* {showEditBillDetailsModal && <EditBillDetailModal modalState={showEditBillDetailsModal} />} */}
        {!isManualForm && <div className='width-100 d-flex flex-row justify-content-around'>
            <AddItemButton icon={"/media/ePulse/upload_image.png"} title={"Enter Manually"} subtitle={"Add medicines details manually"} onClick={handleManuallyDetails} />
            <AddItemButton icon={"/media/ePulse/upload_image.png"} title={"Enter Detail  With OCR "} subtitle={"Choose From Device For OCR"} onClick={handleShowOCR} />
        </div>}



        {isManualForm && <div className='patient-box'>
            <div className='width-100 d-flex flex-row justify-content-between'>
                <div className='width-50 mb-3'>
                    <div className='patient-box'>
                        <span>Invoice Number</span>
                        <div className='input-group'>
                            <input
                                ref={invoiceNumRef}
                                type='string'
                                value={invoiceNum}
                                onChange={(e) => handleInvoiceNumber(e.target.value)}
                                className='form-control px-3'
                                placeholder={"Invoice Number"}
                            />
                        </div>
                        {invoiceNumError && <span style={{ color: 'red' }}>{invoiceNumError}</span>}
                    </div>
                </div>
                <div className='width-50 mb-3'>
                    <div className='patient-box'>
                        <span>Invoice Date</span>
                        <div className='input-group'>
                            <input
                                ref={invoiceDateRef}
                                type='date'
                                className='form-control px-3'
                                value={invoiceDate}
                                onChange={(e) => handleInvoiceDate(e.target.value)}
                            />
                        </div>
                        {invoiceDateError && <span style={{ color: 'red' }}>{invoiceDateError}</span>}
                    </div>
                </div>
            </div>

        </div>}
        {isManualForm && <NewMedicineTable onSubmitDetails={onSubmitDetails} handleTableData={handleTableData} OCRData={orderDetails} />}
        {/* {isManualForm && <MedicineTable onSubmitDetails={onSubmitDetails} handleTableData={handleTableData} OCRData = {orderDetails}/>} */}
        {isShowBillDetail && <BillDetails billDetails={billDetailsfields} handleApiCall={handleApiCall} />}

    </div>
}

export { AddStockPage };